import React, { useContext, useEffect } from "react";
import { motion } from "framer-motion";
import styles from "./Contact.module.scss";
import { Context } from "../Store";
import ContactForm from "./ContactForm";

const Contact = () => {
  let {
    dir,
    translate,
    setIsClicked,
    setIsHovering,
    variants1,
    backgroundBubble0L,
    backgroundBubble0R,
    contactSection,
  } = useContext(Context);
  let { documentTitle, title, det } = translate.contactUs;

  useEffect(() => {
    setIsClicked(false);
    setIsHovering(false);
  }, [setIsClicked, setIsHovering]);
  useEffect(() => {
    document.title = dir === "ltr" ? documentTitle[0] : documentTitle[1];
  }, [dir]);
  return (
    <>
      <motion.section
        variants={variants1}
        initial="hidden"
        animate="showComponets"
        exit="exit"
        ref={contactSection}
        id={styles.contact}
      >
        {dir === "ltr" ? (
          <img
            src={backgroundBubble0L}
            className={styles.backgroundBubbleL}
            alt=""
          />
        ) : (
          <img
            src={backgroundBubble0R}
            className={styles.backgroundBubbleR}
            alt=""
          />
        )}
        <div className={styles.item}>
          <h3>{dir === "ltr" ? title[0] : title[1]}</h3>
          <p>{dir === "ltr" ? det[0] : det[1]}</p>
        </div>
        <ContactForm />
      </motion.section>
    </>
  );
};

export default Contact;
